import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IMembers } from "./routeType";
import { useGetMember } from "./get";
import { useGetAllMembers } from "./getAll";

const { getPath } = getApi("members.put");

type IExtractedRouteType = IMembers["memberProfileSingleUpdate"];

export type IPutMember = IPickMutation<IExtractedRouteType>;

const putMember: MutationFunction<
  IPutMember["response"],
  IPutMember["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.put(getPath({ memberId }), data);
};

export const usePutMember = createMutation({
  mutationFn: putMember,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllMembers.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetMember.getKey({ memberId }),
    });
  },
});
